import React from "react";
import { motion } from "framer-motion";
import { FaWallet, FaMapMarkerAlt, FaChartLine, FaShieldAlt } from "react-icons/fa"; // Importing icons from react-icons/fa

export default function FeaturesSection() {
  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    hover: { scale: 1.05 },
  };

  return (
    <motion.div
      className="container mt-4"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="row align-items-center">
        {/* Feature Icons and Text */}
        <motion.div
          className="col-12 col-lg-6"
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <div className="row">
            {/* Feature 1 */}
            <motion.div
              className="col-md-6 mb-4"
              variants={itemVariants}
            >
              <div className="d-flex p-3 rounded shadow-lg">
                <h5><FaWallet className="fs-1 text-warning me-2"  /></h5>
                <div className="ms-2">
                  <h5 className="">  Low Cost</h5>
                  <p>
                    ed do eiusmod tempor dolor sit amet, conse elit ctetur sed
                    tempor.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Feature 2 */}
            <motion.div
              className="col-md-6 mb-4"
              variants={itemVariants}
            >
              <div className="d-flex p-3 rounded shadow-lg">
                <h5><FaMapMarkerAlt className="fs-1 text-warning" /></h5> 
                <div className="ms-2">
                  <h5>Easy to Find</h5>
                  <p>
                    ed do eiusmod tempor dolor sit amet, conse elit ctetur sed
                    tempor.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Feature 3 */}
            <motion.div
              className="col-md-6 mb-4"
              variants={itemVariants}
            >
              <div className="d-flex p-3 rounded shadow-lg">
               <h5> <FaChartLine className="fs-1 text-warning" /> </h5>
                <div className="ms-2">
                  <h5>Good Marketing</h5>
                  <p>
                    ed do eiusmod tempor dolor sit amet, conse elit ctetur sed
                    tempor.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Feature 4 */}
            <motion.div
              className="col-md-6 mb-4"
              variants={itemVariants}
              transition={0.9}
            >
              <div className="d-flex p-3 rounded shadow-lg">
                <h5>
                <FaShieldAlt className="fs-1 text-warning" /> </h5>
                <div className="ms-2">
                  <h5>Reliable</h5>
                  <p>
                    ed do eiusmod tempor dolor sit amet, conse elit ctetur sed
                    tempor.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Image Section */}
        <motion.div
          className="col-12 col-lg-6"
          variants={itemVariants}
          whileHover="hover"
        >
          <motion.img
            src="/images/feature.webp"
            alt="Features Illustration"
            className="img-fluid"
            whileHover={{ scale: 0.9 }}
          />
        </motion.div>
      </div>
    </motion.div>
  );
}
